module.exports = __webpack_public_path__ + "img/s (5).8ed05663.png";